import { injectable } from "@launchtray/tsyringe-async";
import { Bindable, nameof, NotifyProperty } from "bindable-data";
import { Event } from "event-system";

@injectable()
export class PlayerModel extends Bindable {
    public readonly initialShuffles: number = 1;
    public readonly eraseTrianglesBooster: NotifyProperty<number>;
    public readonly eraseBooster: NotifyProperty<number>;
    public readonly initialRevivals: number = 3;
    private score: number = 0;
    private bestScore: number;
    private shuffles: number;
    private revivals: number;
    public readonly onChanged: Event;
    private isFirstLaunch: boolean;
    public get IsFirstLaunch(): boolean {
        return this.isFirstLaunch;
    }
    public set IsFirstLaunch(value: boolean) {
        this.isFirstLaunch = value;
        localStorage.setItem("isFirstLaunch", JSON.stringify(value));
    }

    public constructor() {
        super();
        this.onChanged = new Event();
        const bestScore = localStorage.getItem("bestScore");
        this.bestScore = bestScore == null ? Infinity : Number.parseInt(bestScore);
        this.shuffles = this.initialShuffles;
        this.eraseTrianglesBooster = new NotifyProperty(this, nameof(this, "eraseTrianglesBooster"), 1);
        this.eraseBooster = new NotifyProperty(this, nameof(this, "eraseBooster"), 1);
        this.revivals = this.initialRevivals;
        const storedIsFirstLaunch = localStorage.getItem("isFirstLaunch");
        if (storedIsFirstLaunch == null) {
            this.IsFirstLaunch = true;
        } else {
            this.IsFirstLaunch = JSON.parse(storedIsFirstLaunch);
        }
    }

    public get Shuffles(): number {
        return this.shuffles;
    }

    public set Shuffles(newValue: number) {
        this.shuffles = newValue;
        if (newValue >= 0){
            this.onChanged.emit();
        }
    }

    public get Score(): number {
        return this.score;
    }

    public set Score(newValue: number) {
        this.score = newValue;
        this.onChanged.emit();
    }

    public get BestScore(): number {
        return this.bestScore;
    }

    public set BestScore(newValue: number) {
        this.bestScore = newValue;
        localStorage.setItem("bestScore", JSON.stringify(newValue));
    }

    public reduceRevival(): void {
        this.revivals--;
    }

    public resetRevivals(): void {
        this.revivals = this.initialRevivals;
    }

    public isHaveRevivals(): boolean {
        return this.revivals > 0;
    }

    public resetAllBoosters(): void {
        this.shuffles = 1;
        this.eraseBooster.setValue(1);
        this.eraseTrianglesBooster.setValue(1);
        this.onChanged.emit();
    }
}